const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://viettrismartcity-api.cgis.asia/",
    domainUserSide: "http://localhost:3000",
    domainAdminSide: "https://viettrismartcity-admin.cgis.asia",
    domainName: "",
    doMainNameGeoServer: "https://geo3.cgis.asia/geoserver/wfs",
    doMainNameGeoServerWMS: "https://geo3.cgis.asia/geoserver/phutho/wms",
    datastore: "phutho",
  },

  production: {
    api: "https://viettrismartcity-api.cgis.asia/",
    domainUserSide: "https://viettrismartcity.cgis.asia",
    domainAdminSide: "https://viettrismartcity-admin.cgis.asia",
    domainName: "viettrismartcity.cgis.asia",
    doMainNameGeoServer: "https://geo3.cgis.asia/geoserver/wfs",
    doMainNameGeoServerWMS: "https://geo3.cgis.asia/geoserver/phutho/wms",
    datastore: "phutho",
  },
};

module.exports = apiEnvironment[env];

// const env = process.env.NODE_ENV || "development";

// const apiEnvironment = {
//   development: {
//     api: "https://pleiku-api.cgis.asia/",
//     domainUserSide: "http://localhost:3000",
//     domainAdminSide: "https://caobangsmartcity.cgis.asia",
//     domainName: "",
//     doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
//     doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/pleiku/wms",
//     datastore: "pleiku",
//   },

//   production: {
//     api: "https://pleiku-api.cgis.asia/",
//     domainUserSide: "https://pleiku.cgis.asia",
//     domainAdminSide: "https://admin.pleiku.cgis.asia",
//     domainName: "pleiku.cgis.asia",
//     doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
//     doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/pleiku/wms/",
//     datastore: "pleiku",
//   },
// };

// module.exports = apiEnvironment[env];